<script>
export default {
  props: {
    note: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      visible: false,
    };
  },

  mounted() {
    this.visible = true;
  },

  computed: {
    title() {
      return this.note ? "แก้ไขบันทึกการติดตามนัดหมาย" : "เพิ่มบันทึกการติดตามนัดหมาย";
    }
  },

  methods: {
    handleClose() {
      this.$emit("close");
      this.visible = false;
    },

    handleClosed() {
      this.$destroy();
    },

    emit(value) {
      this.$emit("action", { "action": value, "note": this.note });

      this.visible = false;
    },

    handleCloseButtonClick() {
      this.visible = false;
    },
  },

  render() {
    const buttons = (() => {
      const cancelButton = (
        <el-button
          class={[
            this.$style.button,
          ]}
          onClick={() => {
            this.visible = false;
          }}
        >
          Cancel 
        </el-button>
      );

      const confirmButton = (
        <el-button
          type="primary"
          class={[
            this.$style.button,
          ]}
          onClick={() => {
            this.emit("confirm");
          }}
        >
          Save
        </el-button>
      );

      return [
        cancelButton,
        confirmButton,
      ]
    })();

    const renderHeader = (() => {

      return <div 
        style={{ 
          margin: "0.5rem 0",
          fontWeight: "bold",
          color: "#020202",
          fontSize: "20px"
        }}>{this.title}</div>
    });

    return (
      <el-dialog
        center
        width="40%"
        visible={this.visible}
        onClose={this.handleClose}
        onClosed={this.handleClosed}
        class={this.$style.root}
      >
        <template slot="title">{renderHeader()}</template>

        <div style={{ marginTop: "1rem" }}>
          <div style={{ marginBottom: "0.5rem" }}>
            <div style={{ textAlign: "center", color: "black" }}>
              <el-input
                type="textarea"
                rows={4}
                placeholder="เพิ่มบันทึกการติดตามนัดหมาย"
                v-model={this.note}>
              </el-input>
            </div>
          </div>
        </div>

        <el-row
          slot="footer"
          type="flex"
          gutter={16}
          justify="center"
          style={{ flexWrap: "wrap" }}
        >
          {buttons.filter(vnode => vnode != undefined).map((vnode) => (
            <el-col span={8}>{vnode}</el-col>
          ))}
        </el-row>
      </el-dialog>

    );
  },
};
</script>

<style lang="scss" module>
.root {
  font-family: Sarabun;
}

.button {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 1.2rem;
  padding: 9px;
}
</style>